/** @file Direction lists per set layout and sector centres as base + factor * diagonal skew. */
import type { Dir } from '@pose2d/format/types';

/**
 * `all` (8-set, CCW from E), the two 4-set layouts, and each direction's centre = base + factor * skew, where
 * skew = 45 (plain) or atan(tileH / tileW) degrees (iso): NE = skew, NW = 180 - skew, SW = skew - 180, SE = -skew.
 */
export const DIRECTION_TABLE: {
  readonly all: readonly Dir[];
  readonly diagonal: readonly Dir[];
  readonly cardinal: readonly Dir[];
  readonly centre: Readonly<Record<Dir, readonly [number, number]>>;
} = {
  all: ['E', 'NE', 'N', 'NW', 'W', 'SW', 'S', 'SE'],
  diagonal: ['NE', 'SE', 'SW', 'NW'],
  cardinal: ['N', 'E', 'S', 'W'],
  centre: { E: [0, 0], NE: [0, 1], N: [90, 0], NW: [180, -1], W: [180, 0], SW: [-180, 1], S: [-90, 0], SE: [0, -1] },
};
